<template>
    <el-container>
        <el-main>
            <el-form :model="searchData" label-position="top" label-width="80px">
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label="搜索词" prop="searchWord" class="cls-col">
                            <el-input v-model="searchData.searchWord" placeholder="搜索词" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                  <el-col :span="4">
                    <el-form-item label="搜索时间开始" prop="clickTime1" class="cls-col">
                      <!-- <el-input v-model="searchData.createTimeStart" placeholder="点击时间开始" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.clickTime1"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="搜索时间结束" prop="clickTime2" class="cls-col">
                      <!-- <el-input v-model="searchData.createTimeEnd" placeholder="点击时间结束" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.clickTime2"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item class="cls-col">
                    <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                </el-form-item>

            </el-form>           
            <el-table
                    :data="modelData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                     @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="searchWord"
                        label="搜索词"
                        align="center"
                >
                </el-table-column>

                <el-table-column
                        prop="searchCount"
                        label="搜索次数"
                        align="center"
                >
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showIpList(scope.row)">查看IP分布</el-button>
                    </template>
                </el-table-column>
            </el-table>
           <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
        <!--ip分布列表 begin-->
        <el-dialog :visible.sync="ipShowVisible"
            center
            width="60%">
            <span class="dialogTitle">ip分布列表</span>
        <el-table
            :data="ipList"
            border
            highlight-selection-row
            style="width: 100%">
            <el-table-column
                type="selection"
                align="center"
                width="55">
            </el-table-column>
            <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center"
                fixed="left"
            >
            <template #default="scope">
                <span>{{scope.$index + 1}}</span>
            </template>
            </el-table-column>
            <el-table-column
                prop="searchWord"
                align="center"
                label="搜索词"
            >
            </el-table-column>
            <el-table-column
                prop="userIp"
                align="center"
                label="用户ip"
            >
            </el-table-column>
            <el-table-column
                prop="ipNation"
                align="center"
                label="ip归属地"
            >
            </el-table-column>
            <el-table-column
                prop="searchTime"
                align="center"
                label="搜索时间"
            >
            </el-table-column>
        </el-table>
        </el-dialog>
        <!--ip分布列表 end-->
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'

    export default {
        name: "log",
        components: {            
        },
        data() {           
            return {
                modelData:[],
                rules: {
                },              
                searchData: {
                    searchWord: null,
                    isFirstSearch: null,
                    userIp: null,
                    createTimeStart: null,
                    createTimeEnd: null,
                    page: 1,
                    size: 10
                },         
                pageSize:10,
                loading: false,
                total: 0,
                multipleSelection : [],
                currentPage: 1,
                ipShowVisible:false,
                ipList:[],
            }
        },
        methods: {   
            handleSizeChange() {
            },
            handleCurrentChange(val) {
                this.search(val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].logId;
                }
            },        
            search(val) {
                console.log(val,'val');
               this.searchData.size = this.pageSize;
               console.log('this.searchData.size',this.searchData.size);
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                if(this.searchData.clickTime1){
                    this.searchData.createTimeStart=this.searchData.clickTime1+" 00:00:00";
                }
                else{
                    this.searchData.createTimeStart=null;
                }
                if(this.searchData.clickTime2){
                    this.searchData.createTimeEnd=this.searchData.clickTime2+" 23:59:59";
                }
                else{
                    this.searchData.createTimeEnd=null;
                }

                let params = this.searchData;
                console.log('param',params);
                  https.fetchPost('/searchStatistic/wordList',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.modelData = data.data.data.list;
                        console.log(' this.modelData', this.modelData);
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            },
            showIpList(row){
                console.log(row);
                this.ipShowVisible = true;
                
                let params = {searchWord:row.searchWord};
                console.log('param',params);
                  https.fetchPost('/searchStatistic/findListByWord',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    console.log('data',data);
                    if(code == '200') {
                        this.ipList = data.data.data;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            }             
        },
        created: function () {
            this.search(1);
        }
    }
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
  .dialogTitle {
    color: #2b2b2b;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    position: absolute;
    font-size: 18px;
    margin-top: -43px;
  }
</style>